import React from "react";
import styles from "./ERPModal.module.css";

import {
  BackArrowButton,
  CancelButton,
  CloseButton,
  ProceedButton,
} from "../../../fixedassetelements/button/Button";

import CalendarIcon from "../../../assets/icons/Calendar.svg";
import ClockIcon from "../../../assets/icons/erpClock.svg";
import UserIcon from "../../../assets/imgs/user2.png";
import MenuIcon from "../../../assets/icons/menuDotBlack.svg";

const ERPModal = ({ onClose, onBack, onProceed, onCancel }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <BackArrowButton onClick={onBack} />
            <h2 className={styles.title}>
              Add Payable Register (Pull from ERP)
            </h2>
          </div>
          <CloseButton onClick={onClose} />
        </div>

        <div className={styles.description}>
          <p>
            Lorem ipsum dolor sit amet consectetur. Neque mattis
            <br />
            nibh cursus sodales pulvinar
          </p>
        </div>

        <div className={styles.content}>
          <div className={styles.cardContainer}>
            {[1, 2, 3, 4].map((item) => (
              <div key={item} className={styles.card}>
                <div className={styles.cardHeader}>
                  <span className={styles.companyName}>
                    Biffco Enterprises Ltd
                  </span>
                  <button className={styles.menuButton}>
                    <img src={MenuIcon} alt="menu" />
                  </button>
                </div>

                <div className={styles.cardBody}>
                  <div className={styles.dateRow}>
                    <div className={styles.dateItem}>
                      <img
                        src={CalendarIcon}
                        alt="calendar"
                        className={styles.iconSmall}
                      />
                      <span className={styles.dateText}>Feb 11, 2025</span>
                    </div>

                    <span className={styles.dateSeparator}>To</span>

                    <div className={styles.dateItem}>
                      <img
                        src={CalendarIcon}
                        alt="calendar"
                        className={styles.iconSmall}
                      />
                      <span className={styles.dateText}>Aug 15, 2025</span>
                    </div>
                  </div>

                  <div className={styles.timeRow}>
                    <img
                      src={ClockIcon}
                      alt="clock"
                      className={styles.iconSmall}
                    />
                    <span className={styles.timeText}>
                      Apr 10, 2025, 08:34 PM
                    </span>
                  </div>

                  <div className={styles.userRow}>
                    <img
                      src={UserIcon}
                      alt="user"
                      className={styles.avatar}
                    />
                    <span className={styles.userName}>Adrienne Vossler</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.footer}>
          <CancelButton onClick={onCancel} />
          <ProceedButton onClick={onProceed} />
        </div>
      </div>
    </div>
  );
};

export default ERPModal;
